import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-tableIcon-expandRow",
  "use": "svg-icon-tableIcon-expandRow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-tableIcon-expandRow\"><path d=\"M6.02 11.6a.74.74 0 01-.527-.216L3.587 9.49a.749.749 0 111.058-1.063l1.374 1.366 1.334-1.335a.752.752 0 111.06 1.059L6.55 11.381a.753.753 0 01-.53.22zm5.067-9.222H.913a.75.75 0 010-1.5h10.174a.75.75 0 110 1.5zm0 3.986H.913a.75.75 0 010-1.5h10.174a.75.75 0 010 1.5z\" fill-rule=\"evenodd\" opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol